export enum RebillyPaymentMethod {
  card = 'payment-card',
}
